//this closure ensures we won't be interferring with other libraries that have defined $
(function($) {
    $.resizeNavigationButtons = function() {
        var tallestOption = 0;
        
        $('.navigation-button').each(function() {
        	if($(this).is(':visible')) {
        		tallestOption = Math.max(tallestOption, $(this).outerHeight());
        	}
        });
        
        $('.navigation-button').each(function() {
            $(this).css('height', tallestOption);
        });
    };
    
    $(document).ready(function() {
        $('.navigation-buttons-section').parent().fadeIn();
        $.resizeNavigationButtons();
    });
})(jQuery);